import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

const ButtonCampaign = ({
  title,
  bordered,
  color,
  small,
  style,
  onClick,
  disabled,
  icon,
  noLabel,
  className,
  ...rest
}) => {
  return (
    <Container
      small={small}
      onClick={onClick}
      bordered={bordered}
      color={color}
      style={style}
      disabled={disabled}
      noLabel={noLabel}
      className={className}
      {...rest}
    >
      <h2>{title}</h2>
    </Container>
  );
};

ButtonCampaign.defaultProps = {
  title: '',
  style: null,
  disabled: false,
  color: null,
  bordered: false,
  small: false,
  onClick: null,
  icon: null,
  noLabel: false,
  className: '',
};

ButtonCampaign.propTypes = {
  title: PropTypes.string,
  bordered: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.shape(),
  disabled: PropTypes.bool,
  small: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  noLabel: PropTypes.bool,
  className: PropTypes.string,
};

export default ButtonCampaign;
